import { render, staticRenderFns } from "./restaurarPass.vue?vue&type=template&id=3366912b&scoped=true"
import script from "./restaurarPass.vue?vue&type=script&lang=js"
export * from "./restaurarPass.vue?vue&type=script&lang=js"
import style0 from "./restaurarPass.vue?vue&type=style&index=0&id=3366912b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3366912b",
  null
  
)

export default component.exports